import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import QCXFinalBondManager from '../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager';
import QCXSelectEmpresaEstrangeiraAutocomplete from '../../shared-components/final-select-empresa-estrangeira-field/QCXSelectEmpresaEstrangeiraAutocomplete';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import useExportadoresBond from './hooks/useExportadoresBond';
import useFabricantesBond from './hooks/useFabricantesBond';
import QCXSelectBoolean from '../../shared-components/select-boolean/QCXSelectBoolean';
import QCXSelectPaisAutocomplete from '../../shared-components/select-pais/QCXSelectPaisAutocomplete';

export default function QCXCatalogoProdutosVinculosFabricantes({ values, isConsult }) {
  const { t } = useTranslation();

  const importadorId = values?.clientes?.[0]?.id;
  const catalogoProdutoId = values?.id;

  const fabricantesBond = useFabricantesBond(values, catalogoProdutoId, importadorId);
  const exportadoresBond = useExportadoresBond(catalogoProdutoId, fabricantesBond.handleAdd);


  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <QCXFormSubtitle title="EXPORTADORES" />
      </Grid>

      <Grid item xs={12}>
        <QCXFinalBondManager
          isParentConsult={isConsult}
          listProps={exportadoresBond.listProps}
          formProps={exportadoresBond.formProps}
          handleAdd={exportadoresBond.handleAdd}
          handleAlreadyExists={exportadoresBond.handleAlreadyExists}
          disableConsult
          controlButtonsGridProps={{
            add: {
              xs: 12,
              sm: 3,
              md: 3,
            },
          }}
        >
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <QCXSelectEmpresaEstrangeiraAutocomplete
              id="select-field-empresa-estrangeira-exportador"
              key="select-field-empresa-estrangeira-exportador"
              name="ignorableFields.exportadorBond.exportadorId"
              label="Exportador"
              initialValues={values}
              filterPredicate={(empresaEstrangeira) => empresaEstrangeira?.exportador && empresaEstrangeira?.active}
              disabled={isConsult}
              importadorId={importadorId}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <QCXSelectBoolean
              id="select-relacao-exp-fab"
              key="select-relacao-exp-fab"
              name="ignorableFields.exportadorBond.relacaoExpFab"
              label="Exportador é o fabricante?"
              initialValues={values}
              defaultValue="NÃO"
              disabled={isConsult}
            />
          </Grid>
        </QCXFinalBondManager>
      </Grid>

      <Grid item xs={12}>
        <QCXFormSubtitle title="FABRICANTES" />
      </Grid>

      <Grid item xs={12}>
        <QCXFinalBondManager
          isParentConsult={isConsult}
          listProps={fabricantesBond.listProps}
          formProps={fabricantesBond.formProps}
          handleAdd={fabricantesBond.handleAdd}
          handleUpdate={fabricantesBond.handleUpdate}
          handleAlreadyExists={fabricantesBond.handleAlreadyExists}
        >
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <QCXSelectBoolean
              id="select-is-conhecido"
              key="select-is-conhecido"
              name="ignorableFields.fabricanteBond.isConhecido"
              label="Fabricante/produtor conhecido?"
              initialValues={values}
              disabled={isConsult}
            />
          </Grid>

          {fabricantesBond.showFabricanteField ? (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <QCXSelectEmpresaEstrangeiraAutocomplete
                id="select-field-empresa-estrangeira-fabricante"
                key="select-field-empresa-estrangeira-fabricante"
                name="ignorableFields.fabricanteBond.fabricanteId"
                label="Fabricante"
                initialValues={values}
                filterPredicate={(empresaEstrangeira) => empresaEstrangeira?.exportador && empresaEstrangeira?.active}
                disabled={isConsult}
                importadorId={importadorId}
              />
            </Grid>
          ) : null}

          {fabricantesBond.showPaisField ? (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <QCXSelectPaisAutocomplete
                name="ignorableFields.fabricanteBond.paisId"
                label={t('com.muralis.qcx.endereco.pais')}
                disabled={isConsult}
                initialValues={values}
              />
            </Grid>
          ) : null}
        </QCXFinalBondManager>
      </Grid>
    </Grid>
  );
}
